import React from 'react';
import axios from "axios";

import { useMantineTheme, Box, Group, Flex, ActionIcon, Card, SimpleGrid, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconArrowsSort } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { regexNoStriped, safeValue, stringDivider, getObjectParam2 } from "../../utils/globalFunctions";

import AmountOfData from "../general/AmountOfData";
import ModalWrapperWithoutFooter from "../general/ModalWrapperWithoutFooter";
import LoaderLine from "../general/LoaderLine";
import SortMenu from "../general/SortMenu";
import NoData from "../general/NoData";
import SearchInputComponent from "../../components/general/SearchInputComponent";

const stepsInclude = [utils.projectProcess.nota.value, utils.projectProcess.antrian.value, utils.projectProcess.pengerjaan.value, utils.projectProcess.qc.value, utils.projectProcess.selesai.value];

const NotaByCustomerSelectorDrawer = ({
    stateShow,
    fnShow,
    fnOnSelect,
    stateData,
}) => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'NotaByCustomerSelectorDrawer-1',
        errorGetDataCustomerCategory: 'NotaByCustomerSelectorDrawer-2',
    })

    const filterDefaultRef = React.useRef({
        // projectPriority: Object.values(utils.priority).map(obj => String(obj.value)),
        projectPriority: utils.flagAll,
    })

    const sortList = {
        projectId: {
            slug: 'project_id',
            caption: 'No Nota',
            type: utils.sortType.string.slug
        },
    }

    const [data, setData] = React.useState({
        data: [],
        dataCount: 0,
        dataFlag: 'idle',
        dataLoading: false,
        dataRefresh: new Date(),
        dataOffset: 0,
        dataSortSelected: sortList.projectId,
        dataSearchInputForBE: '',

        filterData: {
            show: false,
            projectPriority: filterDefaultRef.current.projectPriority,
        },
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const fnSort = (stateSortSelected) => {
        setData(d => ({
            ...d,
            dataLoading: true,
            dataSortSelected: {
                ...d.dataSortSelected,
                slug: d.dataSortSelected.slug[0] === '-' ? stateSortSelected.slug : '-' + stateSortSelected.slug,
                caption: stateSortSelected.caption,
                type: stateSortSelected.type
            }
        }));
    };

    const AmountOfDataComponent = () => {
        return (
            <AmountOfData
                stateDataLimit={utils.dataLimit}
                stateDataOffset={data.dataOffset}
                stateAmountDataAll={data.dataCount}
                stateDataFlag={data.dataFlag}
                stateSuffix=''

                fnFirstData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnLastData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnPreviousData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnNextData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}
            />
        )
    }

    React.useEffect(() => {
        if (stateData.customerId && stateShow) {
            setData(d => ({ ...d, dataLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('data_limit', utils.dataLimit);
            formDT.append('data_offset', data.dataOffset);
            formDT.append('order_by', regexNoStriped(data.dataSortSelected.slug));
            formDT.append('order_type', data.dataSortSelected.slug[0] === '-' ? 'asc' : 'desc');

            formDT.append('flag_all', utils.flagAll);
            formDT.append('filter_search', data.dataSearchInputForBE);
            formDT.append('filter_project_is_cancel', stateData.projectIsCancel);
            formDT.append('filter_project_priority', data.filterData.projectPriority);
            formDT.append('filter_customer_id', stateData.customerId);
            formDT.append('filter_project_steps_include', JSON.stringify(stepsInclude));

            axios({
                method: 'post',
                url: BE_API_ONE + '/get_project_by_customer_id',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, dataLoading: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        data: response.data.data,
                        dataCount: response.data.data_count,
                        dataFlag: response.data.data.length > 0 ? true : false,
                    }));
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    dataLoading: false,
                }));

                notifications.show({
                    id: notificationId.current.errorGetData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh, data.dataSearchInputForBE, data.dataSortSelected.slug, data.dataOffset, data.filterData.projectPriority, stateData.customerId, stateData.projectIsCancel, stateShow, stateData.triggerUpdateSelector])

    return (
        <ModalWrapperWithoutFooter
            stateShow={stateShow}
            fnHide={fnShow}
            stateHideOnClickOutSide={true}
            stateTitle={String('Pilih No Nota').toUpperCase()}
            stateSize='xl'
            stateOverlayZIndex={201}
            stateWithCloseButton={true}
        >
            <Box
                sx={{
                    position: 'relative'
                }}
            >
                <Group
                    noWrap
                    mb='sm'
                    pb="sm"

                    sx={{
                        borderBottom: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[5]}`
                    }}
                >
                    <SortMenu
                        stateSortList={sortList}
                        stateSortSelected={data.dataSortSelected}
                        stateComponentTarget={<ActionIcon
                            size='lg'
                            variant="default"
                            radius='xl'
                        >
                            <IconArrowsSort size='1.25rem' stroke={1} />
                        </ActionIcon>}
                        fnSort={fnSort}
                    />

                    <SearchInputComponent
                        statePlaceHolder='Search Nota'
                        fnDoSearch={(val) => setData(d => ({
                            ...d,
                            dataOffset: 0,
                            dataSearchInputForBE: val,
                            dataRefresh: new Date(),
                        }))}
                    />
                </Group>

                {data.dataLoading &&
                    <LoaderLine
                        statePosition='absolute'
                        stateIsTop={false}
                    />
                }
            </Box>

            {data.data.length > 0 &&
                <SimpleGrid
                    cols={1}
                    spacing='sm'
                    breakpoints={[
                        { minWidth: 'xl', cols: 2, spacing: 'sm' },
                        { minWidth: 'lg', cols: 2, spacing: 'sm' },
                        { minWidth: 'md', cols: 2, spacing: 'sm' },
                        { minWidth: 'sm', cols: 2, spacing: 'sm' },
                        { minWidth: 'xs', cols: 1, spacing: 'sm' },
                    ]}
                >
                    {Object.keys(data.data).map((key, index) => {
                        return (
                            <Card
                                key={key}
                                shadow=''
                                radius="md"
                                withBorder={true}

                                sx={(tema) => ({
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[7],
                                    backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                                    overflow: 'unset',
                                    cursor: 'pointer',
                                    transition: '200ms',
                                    '&:hover': {
                                        borderColor: tema.colorScheme === 'light' ? tema.colors.blue[2] : tema.fn.rgba(tema.colors.blue[6], 0.5),
                                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.blue[0] : tema.fn.rgba(tema.colors.blue[6], 0.1),
                                    }
                                })}

                                onClick={() => fnOnSelect({
                                    projectId: data.data[key].project_id,
                                    projectStep: data.data[key].project_process,
                                    customerName: data.data[key].customer_name,
                                    customerGender: data.data[key].customer_gender,
                                    customerAddress: data.data[key].customer_address,
                                    customerContact: data.data[key].customer_contact,
                                    customerCategoryName: data.data[key].customer_category_name,
                                })}
                            >
                                <Card.Section p='sm'>
                                    <Box>
                                        <Group noWrap position='apart'>
                                            <Text size="sm" fw={500}>
                                                {stringDivider(data.data[key].project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                                            </Text>

                                            <Text size="sm" fw={500}>
                                                {getObjectParam2(utils.projectProcess, data.data[key].project_process, 'caption', ' - ')}
                                            </Text>
                                        </Group>

                                        <Text size="sm" color='dimmed'>
                                            {data.data[key].customer_name} - {data.data[key].customer_category_name}
                                        </Text>

                                        <Text size="xs" color='dimmed'>
                                            {safeValue(data.data[key].customer_address, '')}
                                        </Text>
                                    </Box>
                                </Card.Section>
                            </Card>
                        )
                    })}
                </SimpleGrid>
            }

            {data.data.length <= 0 &&
                <NoData />
            }

            <Flex
                justify="flex-end"
                align="center"
                direction="row"
                wrap='nowrap'
                mt='lg'
            >
                <AmountOfDataComponent />
            </Flex>
        </ModalWrapperWithoutFooter>
    )
}

export default NotaByCustomerSelectorDrawer;